/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Approvals_TitleInputs */

const en_mk_team_approvals_title = /** @type {(inputs: Mk_Team_Approvals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command approvals`)
};

const id_mk_team_approvals_title = /** @type {(inputs: Mk_Team_Approvals_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persetujuan perintah`)
};

/**
* | output |
* | --- |
* | "Command approvals" |
*
* @param {Mk_Team_Approvals_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_approvals_title = /** @type {((inputs?: Mk_Team_Approvals_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Approvals_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_approvals_title(inputs)
	return en_mk_team_approvals_title(inputs)
});